import { useState } from "react";

import { getAuth } from "firebase/auth";
import { app } from "../firebase/firebase-init";

import logo from "../images/logo.png";

const auth = getAuth(app);

const Header = ({ admin }) => {
  const navbarLinks = [
    {
      title: "Home",
      path: "http://chattogram.bcc.gov.bd/",
      event: () => {},
    },
    {
      title: "About",
      path: "http://chattogram.bcc.gov.bd/site/page/81636ea4-eadf-4f86-967a-4f339a75a01c/-",
      event: () => {},
    },
    {
      title: "Services",
      path: "http://chattogram.bcc.gov.bd/site/page/bc906655-b6b1-4f9f-b37a-023d1dd0bc68/-",
      event: () => {},
    },
    {
      title: "Contact",
      path: "http://chattogram.bcc.gov.bd/site/page/4fa14950-402e-4118-a7d2-d28fd988040e/-",
      event: () => {},
    },
    {
      title: admin ? `Logout` : "Login",
      path: "/login",
      event: (e) => {
        e.preventDefault();

        if (admin) {
          auth
            .signOut()
            .then(() => (window.location.href = "/login"))
            .catch((error) => alert(error.message));
          return;
        }

        const user = auth.currentUser;

        if (user) {
          window.location.href = "/admin";
        } else {
          window.location.href = "/login";
        }
      },
    },
  ];

  const [expanded, setExpanded] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg sticky-top bg-white border-bottom shadow-sm">
      <div className="container">
        <a
          className="navbar-brand"
          href="http://chattogram.bcc.gov.bd">
          <img
            src={logo}
            alt="logo"
            width={100}
          />
        </a>

        <button
          onClick={() => setExpanded(!expanded)}
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`collapse navbar-collapse justify-content-end ${
            expanded ? "show" : ""
          }`}
          id="navbarNav">
          <ul className="navbar-nav ml-auto gap-4">
            {navbarLinks.map(({ path, title, event }, index) => (
              <li
                key={index}
                className="nav-item">
                <a
                  onClick={event}
                  className="nav-link text-uppercase"
                  href={path}>
                  {title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
